// Aurora Deutschland GmbH
export const AURORA_STRAINS = [
  {
    id: "aurora-delahaze",
    name: "Delahaze",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Sativa",
    lineage: "Mango × Lemon Skunk",
    thc: 22, cbd: 0.5,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Miętowy", "Sosnowy", "Ziołowy"],
    description: "Odmiana wykazuje silne działanie pobudzające i aktywizujące, a dominujący terpinolen nadaje jej świeży, ziołowy aromat, z lekko cytrusową nutą. Mircen pogłębia relaksację mięśniową zmniejszając napięcie mięśniowe, a kariofilen — wiążąc się bezpośrednio z receptorami CB2 — domyka profil silnym działaniem przeciwzapalnym i przeciwbólowym. Pacjenci zgłaszają poprawę nastroju i koncentracji, brak uczucia otępienia doceniając tę odmianę w godzinach rannych i przedpołudniowych.",
    terpenes: { terpinolen: 30, mircen: 16, pinen: 14, kariofilen: 9, ocymen: 5 },
    dominantTerpene: "Terpinolen", packaging: "10g"
  },
  {
    id: "aurora-ghost-train-haze",
    name: "Ghost Train Haze",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Sativa",
    lineage: "Ghost OG × Neville's Wreck",
    thc: 22, cbd: 0.5,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Korzenny", "Kwaśny", "Sosnowy"],
    description: "Limonen działa pobudzająco i euforyzująco, a dominujący terpinolen, tak częsty w odmianach o charakterze sativa, nadaje charakterystycznego, cytrusowego aromatu. Dodatkowo ocymen wykazuje działanie przeciwzapalne i właściwości ochronne dla komórek nerwowych. Susz wzmaga apetyt, a w wyższych dawkach może działać intensywnie psychoaktywnie. Pacjenci zgłaszają bardzo silne pobudzenie, niektórzy działanie wręcz psychodeliczne i poprawę nastroju, odradzając stosowanie odmiany w godzinach wieczornych.",
    terpenes: { terpinolen: 43, linalol: 4, mircen: 11, pinen: 6, limonen: 10, ocymen: 5 },
    dominantTerpene: "Terpinolen", packaging: "10g"
  },
  {
    id: "aurora-black-jelly",
    name: "Black Jelly",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Hybryda/Sativa",
    lineage: "Alien Cake 3030 × MAC (Miracle Alien Cookies)",
    thc: 27, cbd: 0.5,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Owocowy", "Słodki"],
    description: "Dominujący limonen nadaje suszu wyraźny cytrusowy charakter i odpowiada za działanie przeciwlękowe oraz poprawę nastroju poprzez modulację poziomu serotoniny. Kariofilen — jedyny terpen wiążący się bezpośrednio z receptorami CB2 — wzmacnia efekt przeciwzapalny i przeciwbólowy. Mircen pogłębia relaksację mięśniową, a humulen domyka profil swoimi właściwościami przeciwzapalnymi. Pacjenci opisują działanie jako łagodnie podnoszące nastrój z wyraźną błogością ciała i narastającą sennością po 4–6 godzinach; efekt analgezji i miorelaksacji pojawia się konsekwentnie. Odmiana niepolecana Pacjentom poszukującym wyrazistej euforii i znaczącego podniesienia nastroju — jej profil jest raczej wyciszająco-relaksacyjny niż wyraźnie hedonistyczny.",
    terpenes: { limonen: 26, mircen: 22, kariofilen: 25, humulen: 10, pinen: 5, linalol: 3 },
    dominantTerpene: "Limonen", packaging: "10g"
  },
  {
    id: "aurora-black-jelly-29",
    name: "Black Jelly",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Hybryda/Sativa",
    lineage: "Alien Cake 3030 × MAC (Miracle Alien Cookies)",
    thc: 29, cbd: 0.5,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Owocowy", "Słodki"],
    description: "Dominujący limonen nadaje suszu wyraźny cytrusowy charakter i odpowiada za działanie przeciwlękowe oraz poprawę nastroju poprzez modulację poziomu serotoniny. Kariofilen — jedyny terpen wiążący się bezpośrednio z receptorami CB2 — wzmacnia efekt przeciwzapalny i przeciwbólowy. Mircen pogłębia relaksację mięśniową, a humulen domyka profil swoimi właściwościami i przeciwzapalnymi. Odmiana niepolecana Pacjentom poszukującym wyrazistej euforii i znaczącego podniesienia nastroju — jej profil jest raczej wyciszająco-relaksacyjny niż wyraźnie hedonistyczny.",
    terpenes: { limonen: 26, mircen: 22, kariofilen: 25, humulen: 10, pinen: 5, linalol: 3 },
    dominantTerpene: "Limonen", packaging: "10g",
    dateAdded: "2026-09-01"
  },
  {
    id: "aurora-farm-gas",
    name: "Farm Gas",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Indica",
    lineage: "Sour Diesel × GMO × Chemdawg",
    thc: 27, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Diesel", "Kwaśny", "Pieprzowy", "Ziemisty"],
    description: "Susz często wykazujący najpierw działanie pobudzające, dopiero potem wyciszające i uspokajające, za co odpowiada nerolidol. Dominujący limonen odpowiada za działanie przeciwlękowe oraz poprawę nastroju poprzez modulację poziomu serotoniny. Kariofilen — wiążąc się bezpośrednio z receptorami CB2 — wnosi silne działanie przeciwzapalne i przeciwbólowe, a humulen domyka całość działając ochronnie na komórki błony śluzowej żołądka. Pacjenci opisują szybki onset (kilka minut), maksymalny efekt psychoaktywny po ok. 30 min i działanie do 6 h. Cenią sobie susz za wyraźną poprawę nastroju i relaksację ciała bez efektu \"otępienia\" oraz poprawę jakości snu.",
    terpenes: { limonen: 31, kariofilen: 22, nerolidol: 10, humulen: 8, mircen: 6 },
    dominantTerpene: "Limonen", packaging: "10g"
  },
  {
    id: "aurora-electric-honeydew",
    name: "Electric Honeydew",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Sativa",
    lineage: "Girl Scout Cookies × 91 OG Krypt Melon",
    thc: 29, cbd: 0.5,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Owocowy", "Paliwowy", "Sosnowy"],
    description: "Susz o działaniu pobudzającym i energetyzującym. Limonen wnosi cytrusową świeżość i działa na szlaki serotoninergiczne, wspierając nastrój i redukując napięcie lękowe. Nerolidol i linalol domykają całość, łagodząc przebodźcowanie układu nerwowego i wnosząc kwiatowo-drzewne wyciszenie bez sedacji.",
    terpenes: { mircen: 31, limonen: 15, kariofilen: 13, nerolidol: 12, linalol: 8 },
    dominantTerpene: "Mircen", packaging: "10g"
  },
  {
    id: "aurora-chemango-kush",
    name: "ChemangoTM Kush",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Indica",
    lineage: "OG Kush × Wedding Cake × GMO (Garlic Cookies) × Fuel",
    thc: 29, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Mango", "Cytrusowy", "Sosnowy", "Paliwowy"],
    description: "Dominujący w profilu terpenowym kariofilen, jako jedyny terpen wiążący się z receptorem CB-2 odpowiada za silne działanie przeciwzapalne. Pacjenci zgłaszają silne uczucie relaksacji i poprawę jakości snu, co zawdzięczamy synergistycznemu działaniu mircenu, linalolu i nerolidolu. Susz cechuje ponadto charakterystyczny, cytrusowy zapach dzięki stosunkowo wysokiej zawartości limonenu.",
    terpenes: { kariofilen: 25, limonen: 16, mircen: 14, nerolidol: 16, humulen: 9, linalol: 6 },
    dominantTerpene: "Kariofilen", packaging: "10g"
  },
  {
    id: "aurora-sourdough",
    name: "Sourdough",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Indica",
    lineage: "nieznany rodowód",
    thc: 29, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Kwaśny", "Ziemisty"],
    description: "Dominujący limonen, według relacji Pacjentów odpowiada za działanie suszu zbliżone bardziej sativie niż indice - zgłaszana jest poprawa otwartości, gadatliwość, ułatwienie koncentracji. Mircen odpowiada za sedację i efekt couch-lock, rozluźnia mięśnie i wspiera fazę głębokiego snu. Kariofilen — wiążąc się z receptorami CB2 — zapewnia silne działanie przeciwzapalne i przeciwbólowe, skutecznie łagodząc ból neuropatyczny i mięśniowy. Dodatkowo linalol daje z czasem efekt uspokajający i nasenny. Pacjenci zdecydowanie podkreślają silne działanie leku, ze względu na b. wysoką zawartość THC nie powinien on być stosowany przez Pacjentów dopiero zaczynającyh leczenie konopiami. Ostrożność zachować powinni też Pacjenci z zaburzeniami lękowymi, szczególnie Ci z lękiem panicznym w wywiadzie.",
    terpenes: { limonen: 26, bisabolol: 6, linalol: 10, mircen: 13, kariofilen: 19 },
    dominantTerpene: "Limonen", packaging: "10g"
  },
  {
    id: "aurora-pink-kush",
    name: "Pink Kush",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Indica",
    lineage: "nieznany rodowód",
    thc: 20, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Drzewny", "Pieprzowy", "Pikantny", "Różany"],
    description: "Pink Kush to dominująca indica o THC 20%, przeznaczona do stosowania wieczornego. Mircen głęboko relaksuje mięśnie i działa sedatywnie, limonen łagodzi lęk i może wywoływać początkową euforię, a kariofilen — wiążąc się z receptorami CB2 — zapewnia działanie przeciwzapalne i przeciwbólowe i wzmaga działanie przeciwlękowe. Ponadto bisabolol i linalol powodują odprężenie i poprawiają jakość snu. Pacjenci opisują efekt głębokiej relaksacji z subtelną euforią, redukcją bólu i delikatną sedację.",
    terpenes: { mircen: 25, kariofilen: 18, limonen: 18, nerolidol: 9, linalol: 10, bisabolol: 7 },
    dominantTerpene: "Mircen", packaging: "10g"
  },
  {
    id: "aurora-electric-honeydew-27",
    name: "Electric Honeydew",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Sativa",
    lineage: "Girl Scout Cookies × 91 OG Krypt Melon",
    thc: 27, cbd: 0.5,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Owocowy", "Paliwowy", "Sosnowy"],
    description: "Susz o działaniu pobudzającym i energetyzującym. Limonen wnosi cytrusową świeżość i działa na szlaki serotoninergiczne, wspierając nastrój i redukując napięcie lękowe. Nerolidol i linalol domykają całość, łagodząc przebodźcowanie układu nerwowego i wnosząc kwiatowo-drzewne wyciszenie bez sedacji.",
    terpenes: { mircen: 31, limonen: 15, kariofilen: 13, nerolidol: 12, linalol: 8 },
    dominantTerpene: "Mircen", packaging: "10g"
  },
  {
    id: "aurora-pink-diesel",
    name: "Pink Diesel",
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Indica",
    lineage: "Pink Kush × Driftwood Diesel",
    thc: 29, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Diesel", "Lawendowy", "Pieprzowy"],
    description: "Indica o wysokiej zawartości THC (26,1% - 31,9%) dzięki synergii czterech terpenów, czyli humulenu, pinenu, mircenu i kariofilenu wykazuje silne działanie przeciwbólowe, które w dodatku z dominującym w profilu limonenem istotnie zmniejszają stan zapalny. Ponadto susz powoduje silną sedację i zmniejszenie napięcia mięśniowego, co potęguje obecność mircenu. Odmiana rekomendowana do stosowania w godzinach popołudniowych i wieczornych, zdecydowanie dla doświadczonych pacjentów.",
    descriptionEn: "An indica with a high THC content (26.1% - 31.9%) which, thanks to the synergy of four terpenes — humulene, pinene, myrcene and caryophyllene — shows a strong analgesic effect that, together with limonene dominating the profile, significantly reduces inflammation. In addition, the flower causes strong sedation and a reduction in muscle tension, intensified by the presence of myrcene. Recommended for afternoon and evening use, definitely for experienced patients.",
    terpenes: { limonen: 36, kariofilen: 17, mircen: 12, pinen: 7, humulen: 7 },
    dominantTerpene: "Limonen", packaging: "10g",
    dateAdded: "2026-09-24"
  },
  {
    id: "aurora-cosmic-cream",
    name: "Cosmic Cream",
    dateAdded: "2026-11-01",
    isNew: true,
    producer: "Aurora Deutschland GmbH",
    country: "Kanada",
    genetics: "Indica",
    lineage: "Gasberry Pie × Alien Cake 3030",
    thc: 29, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Słodki", "Waniliowy", "Korzenny"],
    description: "Dominujący kariofilen — jedyny terpen wiążący się bezpośrednio z receptorami CB2 — odpowiada za silne działanie przeciwzapalne i przeciwbólowe, a towarzyszący mu limonen poprawia nastrój i działa przeciwlękowo. Wysoka zawartość linalolu nadaje suszu działanie uspokajające i ułatwiające zasypianie, które pogłębiają mircen i nerolidol. Humulen domyka profil swoimi właściwościami przeciwzapalnymi. Odmiana o wysokiej zawartości THC, rekomendowana do stosowania w godzinach wieczornych, dla doświadczonych pacjentów, szczególnie chwalona przez pacjentów zmagających się z zaburzeniami snu i tikami nerwowymi.",
    descriptionEn: "The dominant caryophyllene — the only terpene that binds directly to CB2 receptors — is responsible for a strong anti-inflammatory and analgesic effect, while the accompanying limonene improves mood and reduces anxiety. The high linalool content gives the flower a calming, sleep-promoting effect, deepened by myrcene and nerolidol. Humulene completes the profile with its anti-inflammatory properties. A high-THC strain recommended for evening use, for experienced patients, and particularly praised by patients struggling with sleep disorders and nervous tics.",
    terpenes: { kariofilen: 26, limonen: 23, linalol: 19, humulen: 8, mircen: 6, nerolidol: 6 },
    dominantTerpene: "Kariofilen", packaging: "10g",
    dateAdded: "2026-10-26"
  }
];